const TIPOS_METADATOS_CREACION = [
  {
    id: 0,
    name: 'Simple'
  },
  {
    id: 1,
    name: 'Lista autoalimentable'
  },
  {
    id: 2,
    name: 'Lista no autoalimentable'
  }
]

export {
  TIPOS_METADATOS_CREACION
}
